module.exports = __webpack_public_path__ + "img/scheme_en.07f86fa1.svg";